<template>
  <div class="socialicon">
    <!-- Twilio -->
    <img
      v-if="type === 'twilio'"
      class="character"
      src="@/app/channels/components/image/twilio.png"
      alt="twilio"
    />
    <!-- <svg
      v-if="type === 'twilio'"
      width="100"
      height="30"
      viewBox="0 0 100 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M70.26 5.87999H64.98C64.86 5.87999 64.74 6.00001 64.74 6.12001V9.17999C64.74 9.29999 64.86 9.42001 64.98 9.42001H70.26C70.38 9.42001 70.5 9.29999 70.5 9.17999V6.12001C70.56 6.00001 70.44 5.87999 70.26 5.87999ZM70.2 10.44H60C59.88 10.44 59.7 10.56 59.64 10.68L58.32 15.66L58.26 15.9L56.7 10.56C56.64 10.44 56.52 10.32 56.34 10.32H52.38C52.26 10.32 52.08 10.44 52.02 10.56L50.52 15.54L50.46 15.78L50.4 15.66L49.8 13.2L49.14 10.74C49.08 10.62 48.96 10.5 48.78 10.5H40.8V6.17999C40.8 6.05999 40.62 5.88 40.44 5.94L35.4 7.5C35.22 7.56 35.16 7.62 35.16 7.74V10.44H33.84C33.72 10.44 33.6 10.56 33.6 10.68V14.52C33.6 14.64 33.72 14.76 33.84 14.76H35.16V19.44C35.16 22.74 36.96 24.3 40.26 24.3C41.64 24.3 42.96 24 43.86 23.52V19.56C43.86 19.38 43.68 19.32 43.56 19.32C43.02 19.56 42.6 19.62 42.12 19.62C41.22 19.62 40.74 19.26 40.74 18.24V14.82H43.62C43.74 14.82 43.86 14.7 43.86 14.58V11.34L47.64 23.88C47.7 24 47.82 24.12 48 24.12H52.2C52.32 24.12 52.5 24 52.56 23.88L54.36 18.3L55.26 21.18L56.1 23.82C56.16 23.94 56.28 24.06 56.46 24.06H60.66C60.78 24.06 60.96 23.94 61.02 23.82L64.86 11.22V23.82C64.86 23.94 64.98 24.06 65.1 24.06H70.2C70.32 24.06 70.44 23.94 70.44 23.82V10.74C70.44 10.56 70.32 10.44 70.2 10.44ZM76.92 5.87999H71.82C71.7 5.87999 71.58 6.00001 71.58 6.12001V23.82C71.58 23.94 71.7 24.06 71.82 24.06H76.92C77.04 24.06 77.16 23.94 77.16 23.82V6.12001C77.16 6.00001 77.04 5.87999 76.92 5.87999ZM83.7 5.87999H78.42C78.3 5.87999 78.18 6.00001 78.18 6.12001V9.17999C78.18 9.29999 78.3 9.42001 78.42 9.42001H83.7C83.82 9.42001 83.94 9.29999 83.94 9.17999V6.12001C84 6.00001 83.88 5.87999 83.7 5.87999ZM83.64 10.44H78.54C78.42 10.44 78.3 10.56 78.3 10.68V23.82C78.3 23.94 78.42 24.06 78.54 24.06H83.64C83.76 24.06 83.88 23.94 83.88 23.82V10.74C83.88 10.56 83.76 10.44 83.64 10.44ZM92.1 10.14C87.6 10.14 84.42 13.44 84.42 17.28V17.34C84.42 21.18 87.6 24.42 92.04 24.42C96.54 24.42 99.72 21.12 99.72 17.28V17.22C99.72 13.38 96.54 10.14 92.1 10.14ZM94.26 17.28C94.26 18.6 93.36 19.62 92.1 19.62C90.84 19.62 89.88 18.54 89.88 17.22V17.16C89.88 15.84 90.78 14.82 92.04 14.82C93.3 14.82 94.26 15.9 94.26 17.28ZM15 0C6.72 0 0 6.72 0 15C0 23.28 6.72 30 15 30C23.28 30 30 23.28 30 15C30 6.72 23.28 0 15 0ZM15 26.04C8.88 26.04 3.96 21.12 3.96 15C3.96 8.88 8.88 3.96 15 3.96C21.12 3.96 26.04 8.88 26.04 15C26.04 21.12 21.12 26.04 15 26.04Z"
        fill="#F12E45"
      />
      <path
        d="M18.7203 14.3997C20.4435 14.3997 21.8403 13.0028 21.8403 11.2797C21.8403 9.55653 20.4435 8.15967 18.7203 8.15967C16.9972 8.15967 15.6003 9.55653 15.6003 11.2797C15.6003 13.0028 16.9972 14.3997 18.7203 14.3997Z"
        fill="#F12E45"
      />
      <path
        d="M18.7203 21.8401C20.4435 21.8401 21.8403 20.4432 21.8403 18.7201C21.8403 16.997 20.4435 15.6001 18.7203 15.6001C16.9972 15.6001 15.6003 16.997 15.6003 18.7201C15.6003 20.4432 16.9972 21.8401 18.7203 21.8401Z"
        fill="#F12E45"
      />
      <path
        d="M11.2801 21.8401C13.0033 21.8401 14.4002 20.4432 14.4002 18.7201C14.4002 16.997 13.0033 15.6001 11.2801 15.6001C9.55702 15.6001 8.16016 16.997 8.16016 18.7201C8.16016 20.4432 9.55702 21.8401 11.2801 21.8401Z"
        fill="#F12E45"
      />
      <path
        d="M11.2801 14.3997C13.0033 14.3997 14.4002 13.0028 14.4002 11.2797C14.4002 9.55653 13.0033 8.15967 11.2801 8.15967C9.55702 8.15967 8.16016 9.55653 8.16016 11.2797C8.16016 13.0028 9.55702 14.3997 11.2801 14.3997Z"
        fill="#F12E45"
      />
    </svg> -->

    <!-- Gupshup -->

    <img
      v-if="type === 'gupshup'"
      class="character"
      src="@/app/channels/components/image/gupshup.jpg"
      alt="gupshup"
    />
    <!-- Instagram -->
    <img
      v-if="type === 'securitec'"
      class="character"
      src="@/app/channels/components/image/securitec.png"
      alt="securitec"
    />
  </div>
</template>
<script>
export default {
  name: "ProviderIcon",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
};
</script>
